import { BrowserRouter } from "react-router-dom";
import React from 'react';
import './App.css';
import AppRoutes from './routes';
import { AuthProvider } from "./context/AuthContext";
import { ToastContainer } from "react-toastify";
import PreventSleep from "component/PreventSleep";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter future={{
        v7_relativeSplatPath: true,
        v7_startTransition: true,
      }}>
        <AppRoutes />
        <PreventSleep />
        <ToastContainer />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
